/**
 * Carrega o dataset de catálogo uma vez por tela e separa carregando / erro /
 * dado (Task 11). Mesmo papel do `DatasetBoundary` do dashboard: nenhuma tela
 * de catálogo repete essa lógica nem confunde erro com lista vazia.
 */
import { createElement as h, type ReactElement } from "react";
import { StatusPanel, errorDetail } from "./StatusPanel.js";
import { useCatalogDataset } from "../queries.js";
import type { CatalogDataset } from "../catalog/dataset.js";

export interface CatalogBoundaryProps {
  children: (dataset: CatalogDataset) => ReactElement;
}

export function CatalogBoundary({ children }: CatalogBoundaryProps): ReactElement {
  const query = useCatalogDataset();
  if (query.isPending) {
    return h(StatusPanel, { kind: "loading", title: "Carregando catálogo e estoque…" });
  }
  if (query.error) {
    return h(StatusPanel, {
      kind: "error",
      title: "Não foi possível carregar o catálogo",
      detail: errorDetail(query.error)
    });
  }
  if (!query.data) {
    return h(StatusPanel, { kind: "empty", title: "Nenhum dado de catálogo retornado pela API da Plataforma" });
  }
  return children(query.data);
}
